(function () {
    'use strict';

    angular.module('app.region', [
        'app.core',
        'ngAnimate',
        'angular.filter',
        'permission',
        'vAccordion'
    ]);
})();
